import React from "react";
import Ingredient from "../Ingredient";
import raw from "../../assets/images/ingredients/bun.png";
import cooked from "../../assets/images/ingredients/bunCut.png";

const Bun = ({ onClick, changeable=true, changed, hideable=true }) => {
    return (
        <Ingredient
            name="Bun"
            image={[raw, cooked]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={onClick}
        />
    );
};

export default Bun;